const { body } = document;

export function bodyOverflow($overflow = true) {
	if ($overflow) {
		body.style.setProperty('overflow', 'hidden');
	} else {
		body.style.setProperty('overflow', '');
	}
}
